// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"1326":"css/admin-app.7055","3797":"css/app.7055"}[chunkId] + ".css";
};